module.exports = __webpack_public_path__ + "media/4PrimaryHealingInvitationToExplore.e3cdafb3.mp3";